import { createReducer } from '@reduxjs/toolkit';
import { activeusername, activeemail , activebrandid, activelocationslist, activelocations, activebusinessname, getmerchantsInfoRequest, getmerchantsInfoFailure, getmerchantsInfoSuccess, saveAggregatorValues, activebrandnames, activebusinessName } from '../../actions/adminFlow/merchantInfoAction';

const initialState = {
	
	merchantsInfoLoading: false,
	merchantsInfoRow: {},
	merchantsInfoRowError: '',
	aggregators: '',
	activebrandnames:'',
	activelocationscount:'',
	activelocationslist:[],
	activebusinessname: '',
	activeusername:'',
	activeemail:'',
	activebrandid:''
}

const merchantsInfoReducer = createReducer(initialState, (builder) => {
    builder
	.addCase(getmerchantsInfoRequest, (state) => { 
		state.merchantsInfoLoading = true;
	}).addCase(getmerchantsInfoSuccess, (state, action) => {
		state.merchantsInfoLoading = false;
		state.merchantsInfoRow = action.payload.data;
		state.merchantsInfoRowError = '';
	}).addCase(getmerchantsInfoFailure, (state, action) => {
		state.merchantsInfoLoading = false;
		state.merchantsInfoRow = null;
		state.merchantsInfoRowError = action.payload.error;
	}).addCase(saveAggregatorValues, (state, action) => {
		state.loading = false;
		state.aggregators = action.payload;
		sessionStorage.setItem('saveAggregatorValues',(state.aggregators).aggregators);
	}).addCase(activebrandnames, (state, action) => {
		state.loading = false;
		state.activebrandnames = action.payload;
		sessionStorage.setItem('activebrandnames',(state.activebrandnames).brandname );
	}).addCase(activebrandid, (state, action) => {
		state.loading = false;
		state.activebrandid = action.payload;
		sessionStorage.setItem('activebrandnames',(state.activebrandnames).brandname );
	}).addCase(activelocations, (state, action) => {
		state.loading = false;
		state.activelocationscount = action.payload; 
		sessionStorage.setItem('activelocationscount',(state.activelocationscount).locations );
	}).addCase(activelocationslist, (state, action) => {
		state.loading = false;
		state.activelocationslist = action.payload;
		sessionStorage.setItem('activelocationslist',(state.activelocationslist).locationslist );
	}).addCase(activebusinessname, (state, action) => {
		state.loading = false;
		state.activebusinessname = action.payload;
		sessionStorage.setItem('activebusinessname',(state.activebusinessname).businessName );
	})
	.addCase(activeusername, (state, action) => {
			state.loading = false;
			state.activeusername = action.payload;
		})
		.addCase(activeemail, (state, action) => {
			state.loading = false;
			state.activeemail = action.payload;
		})
	.addDefaultCase(() => { });
});
export default merchantsInfoReducer;
